import React from "react";
import FlexView from "react-flexview";
import ButtonAction from "../components/ui/buttonAction";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { ACTIVITY_TYPE } from "../../../common/Constants";
import { mapToObjectDDL } from "../../../common/mapper";
import { FormatCurrencyWithoutSymbol } from "../../../../Services/Utils";
import { calculatePercentage, calculatePercentAmount } from "../utils";

export const getTableColumns = ({
  onChangeData,
  jasaOptions,
  dataTable,
  onDelete,
  onSave,
  onAddBackUp,
  onHandlePelanggaran,
  onHandleLocalPelanggaran,
}) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        return page * rowsPerPage + tableMeta.rowIndex + 1;
      },
      setCellProps: () => ({
        style: { width: "3%" },
      }),
    },
  },
  {
    name: "kodeJasa",
    label: "Kode Jasa/Job",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = rowData[rowData.length - 1];
        if (isSaved) {
          return val?.value;
        }
        return (
          <SimpleDDL
            box="search"
            id="id_select_kode_jasa"
            name="kodeJasa"
            containerclassname="width width-200px"
            options={jasaOptions.map((item) => ({
              label: `${item.serviceCode} - ${item.serviceName}`,
              value: item.serviceCode,
              ...item,
            }))}         
            onChange={(value, { name }) => {
              onChangeData(rowIndex, name, value);
              onChangeData(
                rowIndex,
                "namaJasa",
                mapToObjectDDL(value.serviceName, value?.value)
              );
              onChangeData(rowIndex, "serviceCategory", {
                label: value?.serviceCategory?.value,
                value: value?.serviceCategory?.key,
              });

              onChangeData(rowIndex, "prevHargaDiberikan", value?.price);

              onChangeData(rowIndex, "hargaSatuanSistem", value?.price);
              onChangeData(rowIndex, "hargaDiberikan", value?.price);
              onChangeData(rowIndex, "estimasiWaktu", value?.estimationTime);
              onChangeData(rowIndex, "totalHarga", value?.price);
            }}
            value={val}
          />
        );
      },
    },
  },
  {
    name: "namaJasa",
    label: "Nama Jasa/Job",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = rowData[rowData.length - 1];
        if (isSaved) {
          return val?.label;
        }
        return (
          <SimpleDDL
            box="search"
            id="id_select_nama_jasa"
            name="namaJasa"
            containerclassname="width width-200px"
            options={jasaOptions.map((item) => ({
              label: item.serviceName,
              value: item.serviceCode,
              ...item,
            }))}
            
            onChange={(value, { name }) => {
              onChangeData(rowIndex, name, value);
              onChangeData(
                rowIndex,
                "kodeJasa",
                mapToObjectDDL(
                  `${value.serviceCode} - ${value.serviceName}`,
                  value?.serviceCode
                )
              );
              onChangeData(rowIndex, "serviceCategory", {
                label: value?.serviceCategory?.value,
                value: value?.serviceCategory?.key,
              });
              onChangeData(rowIndex, "prevHargaDiberikan", value?.price);

              onChangeData(rowIndex, "hargaSatuanSistem", value?.price);
              onChangeData(rowIndex, "hargaDiberikan", value?.price);
              onChangeData(rowIndex, "estimasiWaktu", value?.estimationTime);
              onChangeData(rowIndex, "totalHarga", value?.price);
            }}
            value={val}
          />
        );
      },
    },
  },
  {
    name: "serviceCategory",
    label: "Service Category",
    options: {
      sort: false,
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        if (isSaved) {
          return val?.label;
        }
        return (
          <SimpleInput
            id="id_input_nama_jasa"
            readOnly
            containerclassname="width width-200px"
            value={val?.label}
          />
        );
      },
    },
  },
  {
    name: "hargaSatuanSistem",
    label: "Harga Satuan Sistem(Rp)",
    options: {
      sort: false,
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        if (isSaved) {
          return FormatCurrencyWithoutSymbol({ number: val });
        }
        return (
          <SimpleInput
            id="id_input_harga_satuan_sistem"
            box="number"
            value={val}
            readOnly
            containerclassname="width width-200px"
          />
        );
      },
    },
  },
  {
    name: "hargaDiberikan",
    label: "Harga Diberikan(Rp)",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = rowData[rowData.length - 1];
        const isSavedPrice = dataTable?.[rowIndex]?.isSavedPrice;
        if (isSaved) {
          return FormatCurrencyWithoutSymbol({ number: val });
        }
        return (
          <FlexView style={{ gap: "15px" }}>
            <SimpleInput
              id="id_input_harga_diberikan"
              box="number"
              readOnly={isSavedPrice}
              value={val}
              containerclassname="width width-200px"
              onValueChange={({ value }) =>
                onChangeData(rowIndex, "hargaDiberikan", value)
              }
            />
            <SimpleButton
              styles={{ width: "unset", marginLeft: "0px", marginTop: "5px" }}
              icon={<i className="txt-site txt-18 fa fa-money-bill" />}
              className="margin-left-20px margin-right-10px"
              category="action_button"
              disable={isSaved}
              onClick={() => {
                if (!isSavedPrice) {
                  const isViolating =
                    Number(val) !==
                    Number(dataTable[rowIndex]?.hargaSatuanSistem || 0);

                  onHandlePelanggaran(isViolating, "APPRV0041");

                  onHandleLocalPelanggaran(
                    "pelanggaranJasa",
                    "pelanggaranHarga",
                    rowIndex,
                    isViolating
                  );
                  if (!val && val !== 0) {
                    onChangeData(
                      rowIndex,
                      "hargaDiberikan",
                      dataTable?.[rowIndex]?.prevHargaDiberikan || 0
                    );
                    onChangeData(
                      rowIndex,
                      "totalHarga",
                      dataTable?.[rowIndex]?.prevHargaDiberikan || 0
                    );
                  } else {
                    onChangeData(rowIndex, "totalHarga", val);
                  }
                  onChangeData(
                    rowIndex,
                    "diskonDiberikan",
                    dataTable?.[rowIndex]?.diskonSistem
                  );
                  onChangeData(
                    rowIndex,
                    "diskonDiberikanCurrency",
                    dataTable?.[rowIndex]?.diskonSistemCurrency
                  );
                }
                onChangeData(rowIndex, "isSavedPrice", !isSavedPrice);
              }}
            />
          </FlexView>
        );
      },
    },
  },

  {
    name: "diskonSistem",
    label: "Diskon Sistem %",
    options: {
      sort: false,
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        if (isSaved) {
          return val;
        }
        return (
          <SimpleInput
            id="id_input_diskon_sistem"
            readOnly={true}
            containerclassname="width width-200px"
            value={val}
          />
        );
      },
    },
  },
  {
    name: "diskonDiberikan",
    label: "Diskon Diberikan %",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = rowData[rowData.length - 1];
        const isSavedDiscount = dataTable?.[rowIndex]?.isSavedDiscount;
        if (isSaved) {
          return val;
        }
        return (
          <FlexView style={{ gap: "15px" }}>
            <SimpleInput
              id="id_input_diskon_diberikan"
              value={val}
              readOnly={isSavedDiscount}
              box="onlyNumberNoDecimal"
              containerclassname="width width-200px"
              max="100"
              onChange={({ target }) => {
                if (val > 100) {
                  onChangeData(rowIndex, "diskonDiberikan", 100);
                } else {
                  onChangeData(rowIndex, "diskonDiberikan", target.value);
                }
              }}
            />
            <SimpleButton
              styles={{ width: "unset", marginLeft: "0px", marginTop: "5px" }}
              icon={<i className="txt-site txt-18 fa fa-money-bill" />}
              className="margin-left-20px margin-right-10px"
              category="action_button"
              disabled={isSaved}
              onClick={() => {
                if (!isSavedDiscount) {
                  const isViolating =
                    Number(val) !==
                    Number(dataTable[rowIndex]?.diskonSistem || 0);
                  onHandlePelanggaran(isViolating, "APPRV0040");
                  onHandleLocalPelanggaran(
                    "pelanggaranJasa",
                    "pelanggaranDiskonPercent",
                    rowIndex,
                    isViolating
                  );
                  if (!val && val !== 0) {
                    onChangeData(
                      rowIndex,
                      "diskonDiberikan",
                      dataTable?.[rowIndex]?.prevDiskonDiberikan || 0
                    );
                  }
                  const hargaDiberikan = dataTable?.[rowIndex].hargaDiberikan;
                  const discAmount = calculatePercentAmount(
                    val,
                    hargaDiberikan
                  );
                  onChangeData(rowIndex, "diskonDiberikanCurrency", discAmount);
                  onChangeData(
                    rowIndex,
                    "totalHarga",
                    hargaDiberikan - discAmount
                  );
                }
                onChangeData(rowIndex, "isSavedDiscount", !isSavedDiscount);
              }}
            />
          </FlexView>
        );
      },
    },
  },
  {
    name: "diskonSistemCurrency",
    label: "Diskon Sistem Currency",
    options: {
      sort: false,
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        if (isSaved) {
          return FormatCurrencyWithoutSymbol({ number: val });
        }
        return (
          <SimpleInput
            id="id_input_diskon_sistem_currency"
            readOnly={true}
            box="number"
            value={val}
            containerclassname="width width-200px"
          />
        );
      },
    },
  },
  {
    name: "diskonDiberikanCurrency",
    label: "Diskon Diberikan Currency",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = rowData[rowData.length - 1];
        const isSavedCurrency = dataTable?.[rowIndex]?.isSavedCurrency;

        if (isSaved) {
          return FormatCurrencyWithoutSymbol({ number: val });
        }
        return (
          <FlexView style={{ gap: "15px" }}>
            <SimpleInput
              id="id_input_diskon_diberikan_currency"
              box="number"
              value={val}
              readOnly={isSavedCurrency}
              containerclassname="width width-200px"
              onValueChange={({ value }) =>
                onChangeData(rowIndex, "diskonDiberikanCurrency", value)
              }
            />
            <SimpleButton
              styles={{ width: "unset", marginLeft: "0px", marginTop: "5px" }}
              icon={<i className="txt-site txt-18 fa fa-money-bill" />}
              className="margin-left-20px margin-right-10px"
              disabled={isSaved}
              category="action_button"
              onClick={() => {
                if (!isSavedCurrency) {
                  const isViolating =
                    Number(val) !==
                    Number(dataTable[rowIndex]?.diskonSistemCurrency || 0);
                  onHandlePelanggaran(isViolating, "APPRV0040");
                  onHandleLocalPelanggaran(
                    "pelanggaranJasa",
                    "pelanggaranDiskon",
                    rowIndex,
                    isViolating
                  );
                  if (!val && val !== 0) {
                    onChangeData(
                      rowIndex,
                      "diskonDiberikanCurrency",
                      dataTable?.[rowIndex]?.prevDiskonDiberikanCurrency || 0
                    );
                  }
                  const hargaDiberikan = dataTable?.[rowIndex].hargaDiberikan;
                  const percent = calculatePercentage(val, hargaDiberikan);
                  onChangeData(rowIndex, "diskonDiberikan", percent);
                  onChangeData(rowIndex, "totalHarga", hargaDiberikan - val);
                }
                onChangeData(rowIndex, "isSavedCurrency", !isSavedCurrency);
              }}
            />
          </FlexView>
        );
      },
    },
  },
  {
    name: "estimasiWaktu",
    label: "Estimasi Waktu",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "5%" },
      }),
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        if (isSaved) {
          return val;
        }
        return (
          <SimpleInput
            id="id_input_estimasi_waktu"
            readOnly={true}
            value={val}
            containerclassname="width width-200px"
          />
        );
      },
    },
  },
  {
    name: "totalHarga",
    label: "Total Harga",
    options: {
      sort: false,
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        if (isSaved) {
          return FormatCurrencyWithoutSymbol({ number: val });
        }
        return (
          <SimpleInput
            id="id_input_total_harga"
            readOnly={true}
            box="number"
            value={val}
            containerclassname="width width-200px"
          />
        );
      },
    },
  },
  {
    name: "isSaved",
    label: "Aksi",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex }) => {
        const dariPackage = dataTable[rowIndex]?.dariPackage;

        return (
          <FlexView style={{ gap: "15px" }}>
            {val ? (
              <ButtonAction
                iconName="fa-pencil-alt"
                onClick={() => {
                  onChangeData(rowIndex, "isSaved", false);
                  onAddBackUp("tableJasa", rowIndex, dataTable[rowIndex]);
                }}
              />
            ) : (
              <ButtonAction
                iconName="fa-save"
                onClick={() => onSave(rowIndex)}
              />
            )}
            <ButtonAction
              iconName="fa-times-circle"
              disabled={dariPackage}
              onClick={() => {
                onDelete(rowIndex);
              }}
            />
          </FlexView>
        );
      },
    },
  },
];

export const getTableColumnsWithQR = ({
  onChangeData,
  partQrOptions,
  dataTable,
  onDelete,
  onSave,
  onAddBackUp,
  onHandlePelanggaran,
  onHandleLocalPelanggaran,
}) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        return page * rowsPerPage + tableMeta.rowIndex + 1;
      },
      setCellProps: () => ({
        style: { width: "5%" },
      }),
    },
  },
  {
    name: "kodePart",
    label: "Kode Part",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = rowData[rowData.length - 1];
        if (isSaved) {
          return val?.value;
        }
        return (
          <SimpleDDL
            box="search"
            id="id_select_kode_part"
            name="kodePart"
            
            options={partQrOptions?.map((item) => ({
              label: `${item.kodePart} - ${item.partName}`,
              value: item.kodePart,
              ...item,
            }))}
            containerclassname="width width-200px"
            value={val}
            onChange={(value, { name }) => {
              onChangeData(rowIndex, name, value);
              onChangeData(
                rowIndex,
                "namaPart",
                mapToObjectDDL(value.partName, value?.kodePart)
              );

              onChangeData(rowIndex, "prevHargaDiberikan", value?.price);

              onChangeData(rowIndex, "qtyPart", value?.partQty || 1);
              onChangeData(rowIndex, "qtyStock", value?.stockQty || 0);
              onChangeData(rowIndex, "hargaSatuanSistem", value?.price);
              onChangeData(rowIndex, "hargaDiberikan", value?.price);
              onChangeData(rowIndex, "totalHarga", value?.price);
            }}
          />
        );
      },
    },
  },
  {
    name: "namaPart",
    label: "Nama Part",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = rowData[rowData.length - 1];
        if (isSaved) {
          return val?.label;
        }
        return (
          <SimpleDDL
            box="search"
            id="id_select_nama_part"
            name="namaPart"
            options={partQrOptions?.map((item) => ({
              label: item.partName,
              value: item.kodePart,
              ...item,
            }))}
            
            containerclassname="width width-200px"
            value={val}
            onChange={(value, { name }) => {
              onChangeData(rowIndex, name, value);
              onChangeData(
                rowIndex,
                "kodePart",
                mapToObjectDDL(
                  `${value.kodePart} - ${value.partName}`,
                  value?.kodePart
                )
              );

              onChangeData(rowIndex, "prevHargaDiberikan", value?.price);

              onChangeData(rowIndex, "qtyPart", value?.partQty || 1);
              onChangeData(rowIndex, "qtyStock", value?.stockQty || 0);
              onChangeData(rowIndex, "hargaSatuanSistem", value?.price);
              onChangeData(rowIndex, "hargaDiberikan", value?.price);
              onChangeData(rowIndex, "totalHarga", value?.price);
            }}
          />
        );
      },
    },
  },
  {
    name: "qtyPart",
    label: "Qty Part",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
      customBodyRender: (val, { rowData, rowIndex }) => {
        const isSaved = rowData[rowData.length - 1];
        if (isSaved) {
          return val;
        }
        return (
          <SimpleInput
            id="id_input_qty_part"
            value={val}
            readOnly
            name="qtyPart"
            onChange={({ target }) => {
              onChangeData(rowIndex, target.name, Number(target.value));
            }}
            containerclassname="width width-100px"
          />
        );
      },
    },
  },
  {
    name: "qtyStock",
    label: "Qty Stock",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        if (isSaved) {
          return val;
        }
        return (
          <SimpleInput
            id="id_input_qty_stock"
            readOnly
            containerclassname="width width-100px"
            value={val}
          />
        );
      },
    },
  },
  {
    name: "qrCode",
    label: "QR Code",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "10%" },
      }),
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        if (isSaved) {
          return val;
        }
        return (
          <React.Fragment>
            <SimpleInput
              id="id_input_qr_code"
              containerclassname="width width-210px"
              value={val}
              readOnly
            />
          </React.Fragment>
        );
      },
    },
  },

  {
    name: "hargaSatuanSistem",
    label: "Harga Satuan Sistem (Rp)",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        if (isSaved) {
          return FormatCurrencyWithoutSymbol({ number: val });
        }
        return (
          <SimpleInput
            id="id_input_harga_satuan_sistem"
            readOnly
            box="number"
            containerclassname="width width-200px"
            value={val}
          />
        );
      },
    },
  },
  {
    name: "hargaDiberikan",
    label: "Harga Diberikan (Rp)",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "10%" },
      }),
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = rowData[rowData.length - 1];
        const isSavedPrice = dataTable?.[rowIndex]?.isSavedPrice;
        if (isSaved) {
          return FormatCurrencyWithoutSymbol({ number: val });
        }
        return (
          <FlexView style={{ gap: "15px" }}>
            <SimpleInput
              id="id_input_harga_diberikan"
              value={val}
              box="number"
              readOnly={isSavedPrice}
              containerclassname="width width-200px"
              onValueChange={({ value }) =>
                onChangeData(rowIndex, "hargaDiberikan", value)
              }
            />
            <SimpleButton
              styles={{ width: "unset", marginLeft: "0px", marginTop: "5px" }}
              icon={<i className="txt-site txt-18 fa fa-money-bill" />}
              className="margin-left-20px margin-right-10px"
              category="action_button"
              onClick={() => {
                if (!isSavedPrice) {
                  const isViolating =
                    Number(val) !==
                    Number(dataTable[rowIndex]?.hargaSatuanSistem || 0);
                  onHandlePelanggaran(isViolating, "APPRV0041");
                  onHandleLocalPelanggaran(
                    "partQr",
                    "pelanggaranHarga",
                    rowIndex,
                    isViolating
                  );
                  if (!val && val !== 0) {
                    onChangeData(
                      rowIndex,
                      "hargaDiberikan",
                      dataTable?.[rowIndex]?.prevHargaDiberikan || 0
                    );
                    onChangeData(
                      rowIndex,
                      "totalHarga",
                      dataTable?.[rowIndex]?.prevHargaDiberikan || 0
                    );
                  } else {
                    onChangeData(rowIndex, "totalHarga", val);
                  }
                  onChangeData(
                    rowIndex,
                    "diskonDiberikan",
                    dataTable?.[rowIndex]?.diskonSistem
                  );
                  onChangeData(
                    rowIndex,
                    "diskonDiberikanCurrency",
                    dataTable?.[rowIndex]?.diskonSistemCurrency
                  );
                }
                onChangeData(rowIndex, "isSavedPrice", !isSavedPrice);
              }}
            />
          </FlexView>
        );
      },
    },
  },
  {
    name: "diskonSistem",
    label: "Diskon Sistem %",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        if (isSaved) {
          return val;
        }
        return (
          <SimpleInput
            id="id_input_diskon_sistem"
            readOnly
            containerclassname="width width-200px"
            value={val}
          />
        );
      },
    },
  },
  {
    name: "diskonDiberikan",
    label: "Diskon Diberikan %",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "10%" },
      }),
      customBodyRender: (val, { rowData, rowIndex }) => {
        const isSaved = rowData[rowData.length - 1];
        const isSavedDiscount = dataTable?.[rowIndex]?.isSavedDiscount;

        if (isSaved) {
          return val;
        }
        return (
          <FlexView style={{ gap: "15px" }}>
            <SimpleInput
              id="id_input_diskon_diberikan"
              containerclassname="width width-200px"
              value={val}
              readOnly={isSavedDiscount}
              onChange={({ target }) =>
                onChangeData(rowIndex, "diskonDiberikan", target.value)
              }
            />
            <SimpleButton
              styles={{ width: "unset", marginLeft: "0px", marginTop: "5px" }}
              icon={<i className="txt-site txt-18 fa fa-money-bill" />}
              className="margin-left-20px margin-right-10px"
              category="action_button"
              onClick={() => {
                if (!isSavedDiscount) {
                  const isViolating =
                    Number(val) !==
                    Number(dataTable[rowIndex]?.diskonSistem || 0);
                  onHandlePelanggaran(isViolating, "APPRV0040");
                  onHandleLocalPelanggaran(
                    "partQr",
                    "pelanggaranDiskonPercent",
                    rowIndex,
                    isViolating
                  );
                  if (!val && val !== 0) {
                    onChangeData(
                      rowIndex,
                      "diskonDiberikan",
                      dataTable?.[rowIndex]?.prevDiskonDiberikan || 0
                    );
                  }
                  const hargaDiberikan = dataTable?.[rowIndex].hargaDiberikan;
                  const discAmount = calculatePercentAmount(
                    val,
                    hargaDiberikan
                  );
                  onChangeData(rowIndex, "diskonDiberikanCurrency", discAmount);
                  onChangeData(
                    rowIndex,
                    "totalHarga",
                    hargaDiberikan - discAmount
                  );
                }
                onChangeData(rowIndex, "isSavedDiscount", !isSavedDiscount);
              }}
            />
          </FlexView>
        );
      },
    },
  },
  {
    name: "diskonSistemCurrency",
    label: "Diskon Sistem Currency",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        if (isSaved) {
          return FormatCurrencyWithoutSymbol({ number: val });
        }
        return (
          <SimpleInput
            id="id_input_diskon_sistem_currency"
            readOnly
            box="number"
            containerclassname="width width-200px"
            value={val}
          />
        );
      },
    },
  },
  {
    name: "diskonDiberikanCurrency",
    label: "Diskon Diberikan Currency",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
      customBodyRender: (val, { rowData, rowIndex }) => {
        const isSaved = rowData[rowData.length - 1];
        const isSavedCurrency = dataTable?.[rowIndex]?.isSavedCurrency;

        if (isSaved) {
          return FormatCurrencyWithoutSymbol({ number: val });
        }
        return (
          <FlexView style={{ gap: "15px" }}>
            <SimpleInput
              id="id_input_diskon_diberikan_currency"
              readOnly={isSavedCurrency}
              box="number"
              value={val}
              containerclassname="width width-200px"
              onValueChange={({ value }) =>
                onChangeData(rowIndex, "diskonDiberikanCurrency", value)
              }
            />
            <SimpleButton
              styles={{ width: "unset", marginLeft: "0px", marginTop: "5px" }}
              icon={<i className="txt-site txt-18 fa fa-money-bill" />}
              className="margin-left-20px margin-right-10px"
              category="action_button"
              onClick={() => {
                if (!isSavedCurrency) {
                  const isViolating =
                    Number(val) !==
                    Number(dataTable[rowIndex]?.diskonSistemCurrency || 0);
                  onHandlePelanggaran(isViolating, "APPRV0040");
                  onHandleLocalPelanggaran(
                    "partQr",
                    "pelanggaranDiskon",
                    rowIndex,
                    isViolating
                  );
                  if (!val && val !== 0) {
                    onChangeData(
                      rowIndex,
                      "diskonDiberikanCurrency",
                      dataTable?.[rowIndex]?.prevDiskonDiberikanCurrency || 0
                    );
                  }
                  const hargaDiberikan = dataTable?.[rowIndex].hargaDiberikan;
                  const percent = calculatePercentage(val, hargaDiberikan);
                  onChangeData(rowIndex, "diskonDiberikan", percent);
                  onChangeData(rowIndex, "totalHarga", hargaDiberikan - val);
                }
                onChangeData(rowIndex, "isSavedCurrency", !isSavedCurrency);
              }}
            />
          </FlexView>
        );
      },
    },
  },
  {
    name: "totalHarga",
    label: "Total Harga",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        if (isSaved) {
          return FormatCurrencyWithoutSymbol({ number: val });
        }
        return (
          <SimpleInput
            id="id_input_total_harga"
            readOnly={true}
            box="number"
            containerclassname="width width-200px"
            value={val}
          />
        );
      },
    },
  },
  {
    name: "isSaved",
    label: "Aksi",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "5%" },
      }),
      customBodyRender: (val, { rowIndex }) => {
        const dariPackage = dataTable[rowIndex]?.dariPackage;
        return (
          <FlexView style={{ gap: "15px" }}>
            {val ? (
              <ButtonAction
                iconName="fa-pencil-alt"
                onClick={() => {
                  onChangeData(rowIndex, "isSaved", false);
                  onAddBackUp("tableQr", rowIndex, dataTable[rowIndex]);
                }}
              />
            ) : (
              <ButtonAction
                iconName="fa-save"
                onClick={() => onSave(rowIndex)}
              />
            )}
            <ButtonAction
              iconName="fa-times-circle"
              disabled={dariPackage}
              onClick={() => {
                onDelete(rowIndex);
              }}
            />
          </FlexView>
        );
      },
    },
  },
];

export const getTableColumnsWithoutQR = ({
  onChangeData,
  partOptions,
  dataTable,
  onDelete,
  onSave,
  onAddBackUp,
  onHandlePelanggaran,
  onHandleLocalPelanggaran,
}) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        return page * rowsPerPage + tableMeta.rowIndex + 1;
      },
      setCellProps: () => ({
        style: { width: "5%" },
      }),
    },
  },
  {
    name: "kodePart",
    label: "Kode Part",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = rowData[rowData.length - 1];
        if (isSaved) {
          return val?.value;
        }
        return (
          <SimpleDDL
            box="search"
            id="id_select_kode_part"
            name="kodePart"
            options={partOptions?.map((item) => ({
              label: `${item.kodePart} - ${item.partName}`,
              value: item.kodePart,
              ...item,
            }))}
            
            containerclassname="width width-200px"
            value={val}
            onChange={(value, { name }) => {
              onChangeData(rowIndex, name, value);
              onChangeData(
                rowIndex,
                "namaPart",
                mapToObjectDDL(value.partName, value?.kodePart)
              );

              onChangeData(rowIndex, "prevHargaDiberikan", value?.price);

              onChangeData(rowIndex, "qtyPart", value?.partQty || 0);
              onChangeData(rowIndex, "qtyStock", value?.stockQty || 0);
              onChangeData(rowIndex, "hargaSatuanSistem", value?.price);
              onChangeData(rowIndex, "hargaDiberikan", value?.price);
              onChangeData(rowIndex, "totalHarga", value?.price);
            }}
          />
        );
      },
    },
  },
  {
    name: "namaPart",
    label: "Nama Part",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = rowData[rowData.length - 1];
        if (isSaved) {
          return val?.label;
        }
        return (
          <SimpleDDL
            box="search"
            id="id_select_nama_part"
            name="namaPart"
            options={partOptions?.map((item) => ({
              label: item.partName,
              value: item.kodePart,
              ...item,
            }))}
            
            containerclassname="width width-200px"
            value={val}
            onChange={(value, { name }) => {
              onChangeData(rowIndex, name, value);
              onChangeData(
                rowIndex,
                "kodePart",
                mapToObjectDDL(
                  `${value.kodePart} - ${value.partName}`,
                  value?.kodePart
                )
              );

              onChangeData(rowIndex, "prevHargaDiberikan", value?.price);

              onChangeData(rowIndex, "qtyPart", value?.partQty || 0);
              onChangeData(rowIndex, "qtyStock", value?.stockQty || 0);
              onChangeData(rowIndex, "hargaSatuanSistem", value?.price);
              onChangeData(rowIndex, "hargaDiberikan", value?.price);
              onChangeData(rowIndex, "totalHarga", value?.price);
            }}
          />
        );
      },
    },
  },
  {
    name: "qtyPart",
    label: "Qty Part",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
      customBodyRender: (val, { rowData, rowIndex }) => {
        const isSaved = rowData[rowData.length - 1];
        if (isSaved) {
          return val;
        }
        return (
          <SimpleInput
            id="id_input_qty_part"
            name="qtyPart"
            value={val}
            onChange={({ target }) => {
              onChangeData(rowIndex, target.name, Number(target.value));
            }}
            containerclassname="width width-100px"
          />
        );
      },
    },
  },
  {
    name: "qtyStock",
    label: "Qty Stock",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        if (isSaved) {
          return val;
        }
        return (
          <SimpleInput
            id="id_input_qty_stock"
            readOnly
            value={val}
            containerclassname="width width-100px"
          />
        );
      },
    },
  },
  {
    name: "hargaSatuanSistem",
    label: "Harga Satuan Sistem (Rp)",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        if (isSaved) {
          return FormatCurrencyWithoutSymbol({ number: val });
        }
        return (
          <SimpleInput
            id="id_input_harga_satuan_sistem"
            readOnly={true}
            box="number"
            containerclassname="width width-200px"
            value={val}
          />
        );
      },
    },
  },
  {
    name: "hargaDiberikan",
    label: "Harga Diberikan (Rp)",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "10%" },
      }),
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = rowData[rowData.length - 1];
        const isSavedPrice = dataTable?.[rowIndex]?.isSavedPrice;
        if (isSaved) {
          return FormatCurrencyWithoutSymbol({ number: val });
        }
        return (
          <FlexView style={{ gap: "15px" }}>
            <SimpleInput
              id="id_input_harga_diberikan"
              box="number"
              readOnly={isSavedPrice}
              value={val}
              containerclassname="width width-200px"
              onValueChange={({ value }) =>
                onChangeData(rowIndex, "hargaDiberikan", value)
              }
            />
            <SimpleButton
              styles={{ width: "unset", marginLeft: "0px", marginTop: "5px" }}
              icon={<i className="txt-site txt-18 fa fa-money-bill" />}
              className="margin-left-20px margin-right-10px"
              category="action_button"
              onClick={() => {
                const qty = dataTable?.[rowIndex].qtyPart;

                if (!isSavedPrice) {
                  if (!val && val !== 0) {
                    onChangeData(
                      rowIndex,
                      "hargaDiberikan",
                      dataTable?.[rowIndex]?.prevHargaDiberikan || 0
                    );
                    onChangeData(
                      rowIndex,
                      "totalHarga",
                      Number(dataTable?.[rowIndex]?.prevHargaDiberikan || 0) *
                        Number(qty)
                    );
                  } else {
                    onChangeData(rowIndex, "totalHarga", val);
                  }
                  onChangeData(
                    rowIndex,
                    "diskonDiberikan",
                    dataTable?.[rowIndex]?.diskonSistem
                  );
                  onChangeData(
                    rowIndex,
                    "diskonDiberikanCurrency",
                    dataTable?.[rowIndex]?.diskonSistemCurrency
                  );

                  const isViolating =
                    Number(val) !==
                    Number(dataTable[rowIndex]?.hargaSatuanSistem || 0);

                  onHandlePelanggaran(isViolating, "APPRV0041");
                  onHandleLocalPelanggaran(
                    "partNonQr",
                    "pelanggaranHarga",
                    rowIndex,
                    isViolating
                  );
                }
                onChangeData(rowIndex, "isSavedPrice", !isSavedPrice);
              }}
            />
          </FlexView>
        );
      },
    },
  },
  {
    name: "diskonSistem",
    label: "Diskon Sistem %",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        if (isSaved) {
          return val;
        }
        return (
          <SimpleInput
            id="id_input_diskon_sistem"
            readOnly={true}
            value={val}
            containerclassname="width width-200px"
          />
        );
      },
    },
  },
  {
    name: "diskonDiberikan",
    label: "Diskon Diberikan %",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "10%" },
      }),
      customBodyRender: (val, { rowData, rowIndex }) => {
        const isSaved = rowData[rowData.length - 1];
        const isSavedDiscount = dataTable?.[rowIndex]?.isSavedDiscount;

        if (isSaved) {
          return val;
        }
        return (
          <FlexView style={{ gap: "15px" }}>
            <SimpleInput
              id="id_input_diskon_diberikan"
              value={val}
              readOnly={isSavedDiscount}
              containerclassname="width width-200px"
              onChange={({ target }) =>
                onChangeData(rowIndex, "diskonDiberikan", target.value)
              }
            />
            <SimpleButton
              styles={{ width: "unset", marginLeft: "0px", marginTop: "5px" }}
              icon={<i className="txt-site txt-18 fa fa-money-bill" />}
              className="margin-left-20px margin-right-10px"
              category="action_button"
              onClick={() => {
                if (!isSavedDiscount) {
                  const isViolating =
                    Number(val) !==
                    Number(dataTable[rowIndex]?.diskonSistem || 0);
                  onHandlePelanggaran(
                    Number(val) >
                      Number(dataTable[rowIndex]?.diskonSistem || 0),
                    "APPRV0040"
                  );
                  onHandleLocalPelanggaran(
                    "partNonQr",
                    "pelanggaranDiskonPercent",
                    rowIndex,
                    isViolating
                  );
                  if (!val && val !== 0) {
                    onChangeData(
                      rowIndex,
                      "diskonDiberikan",
                      dataTable?.[rowIndex]?.prevDiskonDiberikan || 0
                    );
                  }
                  const hargaDiberikan = dataTable?.[rowIndex].hargaDiberikan;
                  const qty = Number(dataTable?.[rowIndex].qtyPart || 0);
                  const discAmount = calculatePercentAmount(
                    val,
                    hargaDiberikan
                  );
                  onChangeData(rowIndex, "diskonDiberikanCurrency", discAmount);
                  onChangeData(
                    rowIndex,
                    "totalHarga",
                    hargaDiberikan * qty - discAmount
                  );
                }
                onChangeData(rowIndex, "isSavedDiscount", !isSavedDiscount);
              }}
            />
          </FlexView>
        );
      },
    },
  },
  {
    name: "diskonSistemCurrency",
    label: "Diskon Sistem Currency",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        if (isSaved) {
          return FormatCurrencyWithoutSymbol({ number: val });
        }
        return (
          <SimpleInput
            id="id_input_diskon_sistem_currency"
            readOnly
            box="number"
            value={val}
            containerclassname="width width-200px"
          />
        );
      },
    },
  },
  {
    name: "diskonDiberikanCurrency",
    label: "Diskon Diberikan Currency",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
      customBodyRender: (val, { rowData, rowIndex }) => {
        const isSaved = rowData[rowData.length - 1];
        const isSavedCurrency = dataTable?.[rowIndex]?.isSavedCurrency;

        if (isSaved) {
          return FormatCurrencyWithoutSymbol({ number: val });
        }
        return (
          <FlexView style={{ gap: "15px" }}>
            <SimpleInput
              id="id_input_diskon_diberikan_currency"
              readOnly={isSavedCurrency}
              box="number"
              value={val}
              containerclassname="width width-200px"
              onValueChange={({ value }) =>
                onChangeData(rowIndex, "diskonDiberikanCurrency", value)
              }
            />
            <SimpleButton
              styles={{ width: "unset", marginLeft: "0px", marginTop: "5px" }}
              icon={<i className="txt-site txt-18 fa fa-money-bill" />}
              className="margin-left-20px margin-right-10px"
              category="action_button"
              onClick={() => {
                if (!isSavedCurrency) {
                  const isViolating =
                    Number(val) !==
                    Number(dataTable[rowIndex]?.diskonSistemCurrency || 0);
                  onHandlePelanggaran(isViolating, "APPRV0040");
                  onHandleLocalPelanggaran(
                    "partNonQr",
                    "pelanggaranDiskon",
                    rowIndex,
                    isViolating
                  );
                  if (!val && val !== 0) {
                    onChangeData(
                      rowIndex,
                      "diskonDiberikanCurrency",
                      dataTable?.[rowIndex]?.prevDiskonDiberikanCurrency || 0
                    );
                  }
                  const hargaDiberikan = dataTable?.[rowIndex].hargaDiberikan;
                  const qty = dataTable?.[rowIndex].qtyPart;
                  const percent = calculatePercentage(
                    Number(val),
                    hargaDiberikan
                  );
                  onChangeData(rowIndex, "diskonDiberikan", percent);
                  onChangeData(
                    rowIndex,
                    "totalHarga",
                    hargaDiberikan * qty - Number(val)
                  );
                }
                onChangeData(rowIndex, "isSavedCurrency", !isSavedCurrency);
              }}
            />
          </FlexView>
        );
      },
    },
  },
  {
    name: "totalHarga",
    label: "Total Harga",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "8%" },
      }),
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        if (isSaved) {
          return FormatCurrencyWithoutSymbol({ number: val });
        }
        return (
          <SimpleInput
            id="id_input_total_harga"
            readOnly={true}
            box="number"
            containerclassname="width width-200px"
            value={val}
          />
        );
      },
    },
  },
  {
    name: "isSaved",
    label: "Aksi",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "5%" },
      }),
      customBodyRender: (val, { rowIndex }) => {
        const dariPackage = dataTable[rowIndex]?.dariPackage;
        return (
          <FlexView style={{ gap: "15px" }}>
            {val ? (
              <ButtonAction
                iconName="fa-pencil-alt"
                onClick={() => {
                  onChangeData(rowIndex, "isSaved", false);
                  onAddBackUp("tableNonQr", rowIndex, dataTable[rowIndex]);
                }}
              />
            ) : (
              <ButtonAction
                iconName="fa-save"
                onClick={() => onSave(rowIndex)}
              />
            )}
            <ButtonAction
              iconName="fa-times-circle"
              disabled={dariPackage}
              onClick={() => {
                onDelete(rowIndex);
              }}
            />
          </FlexView>
        );
      },
    },
  },
];
